import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ContentBox, Button } from '@portal/kit/pkg/components'
import RanRoomCard from 'components/ran/ran-room-card'

import styles from './dashboard-style'
import { hasOffers } from 'helpers/ran'
import Subscription from './connection-boxes/subscription'
import RunningTickets from './connection-boxes/running-tickets'
import OutOfNetwork from './connection-boxes/out-of-network'
import { SubscriptionContext } from 'components/providers/subscription'

const RanAdvert = props =>
  <ContentBox>
    <div className={props.classes.ranPromoTextbox}>
      <p className={props.classes.ranPromoTitle}>{props.t('ran_home_ad.title')}</p>
      <p className={props.classes.ranPromoText}>{props.t('ran_home_ad.desc')}</p>
      <p className={props.classes.ranPromoLink}>
        <Button to="/ran">{props.hasRanOffers ? props.t('ran_home_ad.discover_options') : props.t('ran_home_ad.button')}</Button>
      </p>
    </div>
  </ContentBox>

const Welcome = props =>
  <ContentBox>
    <p className={props.classes.welcomeText}>
      <span className={props.classes.welcomeTextWelcome}>{props.t('internet_access.welcome')} </span>
      <span className={props.classes.welcomeTextAccount}>{props.t('internet_access.into_your_account')}</span>
    </p>
    <span className={classNames('fal', 'fa-user', props.classes.welcomeIcon)} />
  </ContentBox>

const Advertisement = props => {

  if(!props.data) return null

  return (
    <ContentBox>
      {props.data.image &&
        <div className={props.classes.advertisementImgWrap}>
          <span className={props.classes.advertisementImg} style={{ backgroundImage: `url(${props.data.image.url})`}} />
        </div>
      }
      <p className={props.classes.advertisementTitle}>{props.data.title}</p>
      <p className={props.classes.advertisementContent}>
        {
          (props.data.content || '').split('\n').map((item, i) => {
            return <span key={i}>{item}<br /></span>
          })
        }
      </p>
      {props.data.signature && <p className={props.classes.advertisementSignature}>{props.data.signature}</p>}
    </ContentBox>
  )
}

const RanRooms = props => <ContentBox>{props.rooms.map(room => <RanRoomCard key={room.id} data={room} isNetworkDisplayed={false} />)}</ContentBox>

const Dashboard = props => {
  const sharedProps = { ...props, classes: styles(props.theme) }
  const outOfNetwork = !props.portalConfiguration || props.portalConfiguration.out_of_network || (props.runningTickets && props.runningTickets.length === 0)

  const { subscriptions } = useContext(SubscriptionContext)

  return (
    <Fragment>
      {props.ranEnabled && !props.ranActivated
        ? <RanAdvert {...sharedProps} hasRanOffers={hasOffers(props)} />
        : <Welcome {...sharedProps} />
      }

      {subscriptions && subscriptions.map(sub => <Subscription subscription={sub} key={sub.id}/>)}

      {!props.ranActivated && outOfNetwork && <OutOfNetwork {...sharedProps} />}

      {props.ranActivated && <RanRooms {...sharedProps} />}

      {!props.ranActivated && props.runningTickets && <RunningTickets {...sharedProps} />}

      {props.advertisement && <Advertisement data={props.advertisement} {...sharedProps} />}
    </Fragment>
  )
}

Dashboard.propTypes = {
  portalConfiguration: PropTypes.object,
  runningTickets: PropTypes.array,
  theme: PropTypes.object.isRequired,
}

export default compose(
  withTranslation(),
  withTheme
)(Dashboard)
